import React, { ReactNode, useCallback } from 'react';
import { isGridLayout, Offer, SelectedProduct } from '../../types';
import { useProductsContext } from '../../contexts/ProductsContext';
import { usePopupContext } from '../../contexts/Settings';
import { OfferBodyGrid } from './grid';
import { OfferBodyTree } from './tree';

interface Props {
  offer: Offer;
  indexInOffers?: number;
  offerId: number;
  variantID?: number;
  cyData: string;
  upsellListItemCustomClassName?: string;
  img: ReactNode;
  animatedIcon: ReactNode | null;
  loading: boolean;
  added: boolean;
  select?: (className: string) => ReactNode | null;
  primaryButton: ReactNode;
  quantity: number;
  label?: string;
  handleRemoveFromCartClick: () => Promise<void>;
  setOfferNote: (note: string) => void;
  offerNote?: string;
  offerDescriptionHeading: ReactNode;
  offerCount: number;
  handleOfferQuantityChange: React.Dispatch<React.SetStateAction<number>>;
  hidden?: boolean;
  id?: number;
}

export const OfferBody = ({
  offer,
  indexInOffers,
  offerId,
  cyData,
  img,
  animatedIcon,
  loading,
  added,
  select,
  handleRemoveFromCartClick,
  primaryButton,
  setOfferNote,
  offerNote = '',
  offerDescriptionHeading,
  quantity,
  offerCount,
  handleOfferQuantityChange,
  upsellListItemCustomClassName = '',
  hidden,
  id,
  variantID,
}: Props) => {
  const { setSelectedProduct } = useProductsContext();
  const { settings } = usePopupContext();

  const openDetail = useCallback(
    () =>
      setSelectedProduct({
        productID: offerId,
        variantID,
        offerID: offer.id,
      } as SelectedProduct),
    [offer.id, offerId, setSelectedProduct, variantID],
  );

  return isGridLayout(settings) ? (
    <OfferBodyGrid
      id={id}
      hidden={hidden}
      offer={offer}
      cyData={cyData}
      img={img}
      animatedIcon={animatedIcon}
      loading={loading}
      added={added}
      select={select}
      handleRemoveFromCartClick={handleRemoveFromCartClick}
      primaryButton={primaryButton}
      setOfferNote={setOfferNote}
      offerNote={offerNote}
      offerDescriptionHeading={offerDescriptionHeading}
      quantity={quantity}
      handleOfferQuantityChange={handleOfferQuantityChange}
      openDetail={openDetail}
      upsellListItemCustomClassName={upsellListItemCustomClassName}
    />
  ) : (
    <OfferBodyTree
      id={id}
      indexInOffers={indexInOffers}
      hidden={hidden}
      offer={offer}
      offerCount={offerCount}
      cyData={cyData}
      img={img}
      animatedIcon={animatedIcon}
      loading={loading}
      added={added}
      select={select}
      handleRemoveFromCartClick={handleRemoveFromCartClick}
      primaryButton={primaryButton}
      setOfferNote={setOfferNote}
      offerNote={offerNote}
      offerDescriptionHeading={offerDescriptionHeading}
      quantity={quantity}
      handleOfferQuantityChange={handleOfferQuantityChange}
      openDetail={openDetail}
      upsellListItemCustomClassName={upsellListItemCustomClassName}
    />
  );
};
